import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	width: 100%;
	border-radius: ${helpers.borderRadius};
	margin: 0 0 ${helpers.spacing.xLarge};
`
